var map = {
	"./arabic.ts": 52968,
	"./chinese.ts": 30769,
	"./chineseYY.ts": 72975,
	"./english.ts": 69146,
	"./french.ts": 6484,
	"./german.ts": 26322,
	"./italian.ts": 53450,
	"./japanese.ts": 40571,
	"./korean.ts": 88272,
	"./portuguese.ts": 9653,
	"./russian.ts": 89031,
	"./spanish.ts": 27402,
	"./turkish.ts": 90314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95005;